import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { SavedView } from "../SavedViewsMenu.types.ts";
import { FilterPage } from "../../../pageView/PageView.types.ts";
import { Result } from "../../../api/result.ts";
import { post } from "../../../api/apiShared.ts";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { buildSavedViewScopeQuery } from "../SavedViewsMenu.hooks.ts";

export interface IDefaultViewHook {
    view: SavedView;
    savedViewType: FilterPage;
    scopeId?: string;
    secondaryScopeId?: string;
    onClose: () => void;
    onSuccess: () => void;
}

export function useSetDefaultViewHook(props: IDefaultViewHook) {
    const snackbar = useDotLegalSnackbar();

    const setDefaultMutation = useDotLegalMutation(setAsDefault);

    const handleSetDefault = () => {
        setDefaultMutation.mutateAsync(
            { viewId: props.view.id, savedViewType: props.savedViewType, scopeId: props.scopeId, secondaryScopeId: props.secondaryScopeId },
            {
                onSuccess: (response: Result<string>) => {
                    snackbar.show(
                        createElement(Trans, {
                            i18nKey: "viewSetAsDefault",
                            values: { name: props.view.name },
                        })
                    );
                    props.onClose();
                    props.onSuccess();
                },
            }
        );
    };

    return {
        handleSetDefault,
        inProgress: setDefaultMutation.isLoading,
    };

    async function setAsDefault(data: { viewId: string; savedViewType: FilterPage; scopeId?: string; secondaryScopeId?: string }) {
        const scopeQuery = buildSavedViewScopeQuery(data.scopeId, data.secondaryScopeId);
        return await post<string>(`/saved-views/${data.viewId}/set-default?savedViewType=${data.savedViewType}${scopeQuery}`, {});
    }
}
